import React, { createRef, useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import AddFoodProductsForm from "../../components/FoodProductsList/AddFoodProductsForm";
import "./FoodProductsList.css";
import { setCaption } from "../../../../common/redux/actions/interfaceActions";
import { useDispatch, useSelector } from "react-redux";
import FoodProductsTable from "../../components/FoodProductsList/FoodProductsTable";
import Sidebar from "../../components/FoodProductsList/Sidebar";
import { getOrderById } from "../../../Executorship/Order/redux/actions/orderCard";
import {
  addFoodProductToList,
  deleteFoodProduct,
  editFoodProduct,
  getFoodProductList
} from "../../redux/actions/foodProductListAction";

const FoodProductsList = ({ match, history }) => {
  const formRef = createRef();
  const dispatch = useDispatch();
  const orderId = match.params.id;
  const updated = useSelector(state => state.Lists.foodProductList.updated);
  const order = useSelector(state => state.Executorship.Orders.orderCard.data);
  const foodProductsData = useSelector(
    state => state.Lists.foodProductList.foodProducts
  );
  const buttonLoading = useSelector(
    state => state.Lists.foodProductList.buttonLoading
  );
  const tableLoading = useSelector(
    state => state.Lists.foodProductList.tableLoading
  );

  const [formShown, toggleFormShown] = useState(false);
  const [editingFoodProductInfo, toggleEditingFoodProductInfo] = useState(
    false
  );
  const [foodProductId, setFoodProductId] = useState(null);

  const driver = order && order.driver;
  const driverId = order && order.driverId;
  const vehicleId = order && order.vehicleId;
  const vehicle = order && order.vehicle;
  const responsible = order && order.responsible;
  const responsibleId =
    order && order.responsible && order.responsible.profileId;
  const orderStatusName = order && order.orderStatusName;
  const arrivalDatetime = order && order.arrivalDatetime;

  useEffect(() => {
    initCaption();
  }, [order]);

  useEffect(() => {
    dispatch(getOrderById(orderId));
    dispatch(getFoodProductList(orderId, null, null));
  }, [orderId]);

  useEffect(() => {
    if (foodProductId) {
      const currentFoodProductInfo = foodProductsData.data.find(
        food_product =>
          food_product.food_product_id === foodProductId && food_product
      );
      if (formRef && editingFoodProductInfo) {
        formRef.current.form.setFieldsValue({
          food_product_name: currentFoodProductInfo.food_product_name,
          food_product_volume: currentFoodProductInfo.food_product_volume
        });
      }
    }
  }, [editingFoodProductInfo, foodProductId]);

  useEffect(() => {
    setFoodProductId(null);
  }, [updated]);

  const handleAddPersonFormSubmit = values => {
    if (editingFoodProductInfo) {
      dispatch(editFoodProduct({ ...values, orderId, foodProductId }));
    } else {
      dispatch(addFoodProductToList({ ...values, orderId }));
    }
  };

  const initCaption = () => {
    const orderNumber =
      order &&
      order.number &&
      order.number.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1 `);

    dispatch(
      setCaption({
        enabled: true,
        mainCaption: orderNumber,
        breadCrumbs: [
          {
            path: "/control-panel",
            breadcrumbName: "Панель управления"
          },
          { path: "/executorship/order", breadcrumbName: "Исполнительство" },
          {
            path: "/executorship/order/" + orderId,
            breadcrumbName: "Заказ - " + orderNumber
          }
        ]
      })
    );
  };

  const innerHandleSubmit = () => {
    const values = formRef.current.form.getFieldsValue();
    let filledValues = {};

    for (const key in values) {
      if (values[key] !== undefined) {
        filledValues[key] = values[key];
      }
    }

    handleAddPersonFormSubmit({ ...filledValues });
  };

  const deleteFoodProductFromList = foodProductId => {
    dispatch(deleteFoodProduct({ orderId, foodProductId }));
  };

  const initEditFoodProduct = foodProductId => {
    toggleFormShown(true);
    toggleEditingFoodProductInfo(true);
    setFoodProductId(foodProductId);
  };

  const changeTable = (pagination, _, sorter) => {
    dispatch(getFoodProductList(orderId, pagination, sorter));
  };

  const changePageSize = pages => {
    const pagination = {
      pageSize: pages && parseInt(pages),
      total: foodProductsData.total,
      current: foodProductsData.current_page
    };
    dispatch(getFoodProductList(orderId, pagination, null));
  };

  const handleCancelButton = () => {
    if (editingFoodProductInfo) {
      toggleFormShown(false);
      toggleEditingFoodProductInfo(false);
      formRef.current.form.resetFields();
    } else {
      toggleFormShown(false);
      formRef.current.form.resetFields();
    }
  };

  return (
    <div className={"site-wrapper"}>
      <Row gutter={16} className={"food-products-cols"}>
        <Col span={18}>
          {formShown && (
            <div className={"food-products-form-space"}>
              <AddFoodProductsForm
                wrappedComponentRef={formRef}
                editingFoodProductInfo={editingFoodProductInfo}
              />
              <div className={"food-products-button-wrapper"}>
                <Button
                  type="danger"
                  ghost
                  htmlType={"button"}
                  style={{
                    width: 176,
                    marginRight: 16
                  }}
                  onClick={handleCancelButton}
                >
                  Отмена
                </Button>
                {!editingFoodProductInfo && (
                  <Button
                    type="primary"
                    htmlType={"submit"}
                    ghost
                    form="add-food-products-form"
                    onClick={() => {
                      innerHandleSubmit();
                      formRef.current.form.resetFields();
                    }}
                    style={{
                      width: 176,
                      marginRight: 16
                    }}
                    loading={buttonLoading}
                  >
                    Еще продукт
                  </Button>
                )}
                <Button
                  type="primary"
                  htmlType={"submit"}
                  form="add-food-products-form"
                  style={{
                    width: 176
                  }}
                  loading={buttonLoading}
                  onClick={() => {
                    innerHandleSubmit();
                    toggleFormShown(false);
                    formRef.current.form.resetFields();
                  }}
                >
                  Сохранить
                </Button>
              </div>
            </div>
          )}
          <FoodProductsTable
            data={foodProductsData}
            onChange={changeTable}
            changePageSize={changePageSize}
            loading={tableLoading}
            deleteFoodProductFromList={deleteFoodProductFromList}
            editFoodProduct={initEditFoodProduct}
          />
        </Col>
        <Col span={6}>
          <Sidebar
            toggleFormShown={toggleFormShown}
            formShown={formShown}
            driver={{ driver, driverId }}
            vehicle={{ vehicleId, vehicle }}
            responsible={{ ...responsible, responsibleId }}
            foodProductsCount={foodProductsData.total}
            // creator={creatorId, name, lastname,patronymic}
            // responsible={performerId: 111, name, lastname, patronymic}
            orderStatusName={orderStatusName}
            arrivalDatetime={arrivalDatetime}
            goBack={() => {
              history.goBack();
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default FoodProductsList;
